// components/CompatibleDevices.js
import React from 'react';
import { DevicePhoneMobileIcon, DeviceTabletIcon } from '@heroicons/react/24/solid';

const CompatibleDevices = () => {
  const iPhones = [
    { name: 'iPhone 15 Pro', releaseYear: 2023 },
    { name: 'iPhone 15 Pro Max', releaseYear: 2023 },
    { name: 'iPhone 14 Pro', releaseYear: 2022 },
    { name: 'iPhone 14 Pro Max', releaseYear: 2022 },
    { name: 'iPhone 13 Pro', releaseYear: 2021 },
    { name: 'iPhone 13 Pro Max', releaseYear: 2021 },
    { name: 'iPhone 12 Pro', releaseYear: 2020 },
    { name: 'iPhone 12 Pro Max', releaseYear: 2020 },
  ];

  const iPads = [
    { name: 'iPad Pro 12.9-inch (6th Gen)', releaseYear: 2022 },
    { name: 'iPad Pro 11-inch (4th Gen)', releaseYear: 2022 },
    { name: 'iPad Pro 12.9-inch (5th Gen)', releaseYear: 2021 },
    { name: 'iPad Pro 11-inch (3rd Gen)', releaseYear: 2021 },
    { name: 'iPad Pro 12.9-inch (4th Gen)', releaseYear: 2020 },
    { name: 'iPad Pro 11-inch (2nd Gen)', releaseYear: 2020 },
  ];

  return (
    <section className="py-20 bg-gray-50" id="compatible-devices">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h3 className="text-primary uppercase font-semibold text-sm mb-2">Compatible Devices</h3>
        </div>

        <div className="flex flex-col lg:flex-row justify-center gap-12">
          {/* iPhones Card */}
          <div className="w-full lg:w-1/2 bg-white rounded-lg shadow-md p-8">
            <div className="flex items-center justify-center mb-6">
              <div className="bg-yellow-100 p-3 rounded-md">
                <DevicePhoneMobileIcon className="h-6 w-6 text-yellow-600" />
              </div>
              <h3 className="ml-4 text-xl font-medium text-gray-800">iPhones</h3>
            </div>
            <ul className="space-y-3">
              {iPhones.map((phone, index) => (
                <li key={index} className="flex items-center">
                  <span className="inline-block w-2 h-2 bg-yellow-600 rounded-full mr-3"></span>
                  <span className="text-gray-700">{phone.name} ({phone.releaseYear})</span>
                </li>
              ))}
            </ul>
          </div>

          {/* iPads Card */}
          <div className="w-full lg:w-1/2 bg-white rounded-lg shadow-md p-8">
            <div className="flex items-center justify-center mb-6">
              <div className="bg-yellow-100 p-3 rounded-md">
                <DeviceTabletIcon className="h-6 w-6 text-yellow-600" />
              </div>
              <h3 className="ml-4 text-xl font-medium text-gray-800">iPads</h3>
            </div>
            <ul className="space-y-3">
              {iPads.map((ipad, index) => (
                <li key={index} className="flex items-center">
                  <span className="inline-block w-2 h-2 bg-yellow-600 rounded-full mr-3"></span>
                  <span className="text-gray-700">{ipad.name} ({ipad.releaseYear})</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompatibleDevices;
